export const localeSelected = 'LOCALE_SELECTED';
export const resolveLocale = 'RESOLVE_LOCALE';

export default {
    selected: localeSelected,
    resolve: resolveLocale
};
